import { render, staticRenderFns } from "./booqit.vue?vue&type=template&id=a28c96a0&"
import script from "./booqit.vue?vue&type=script&lang=js&"
export * from "./booqit.vue?vue&type=script&lang=js&"
import style0 from "./booqit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports